import React, { useEffect } from 'react';
import {mostrarEnumsSinoEsta} from '../../redux/reducers/enumsReducers';
import {FormControl, InputLabel} from "@mui/material";
import Strings from "../../assets/strings"
import {SelectSmart} from "../CustomTextField";
import {hasPermissionTo, PERSMISOS_USUARIOS, translateText} from "../../helpers";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {IKeyValue} from "../../redux/types/Icommon";

type IProps = {
    required?: boolean
    disabled?: boolean
    margin?: "none" | "dense" | "normal" | undefined
    value?: number
    name?: string
    label?: string
    all?: boolean
    onChange?:any
    group: string
}
export default function SelectEnum({required,disabled,margin="none",value, name="tipo",label="", all=false, onChange, group}:IProps) {
    const dispatch = useAppDispatch();
    const enums = useAppSelector(state => state.enums);



    useEffect(() => {
        dispatch(mostrarEnumsSinoEsta())
    }, [dispatch]);


    let options = (enums.list[group] && enums.list[group].map((opc:IKeyValue)=>({key:opc.key,value: translateText(opc.value)}))) || [];

    //pemiso para diario y semanan
    if(group === "ciclosPago" && !hasPermissionTo(PERSMISOS_USUARIOS.cilosPago)){
        options = options.filter((o:IKeyValue)=>o.key === 1 || o.key === 7)
    }
    options.unshift({key:all?-1:undefined,value:all?Strings.todo:Strings.seleccione})


    if(!onChange){
        let opcion = options.find((o:any)=>o.key === value)
        if(opcion) return <>{translateText(opcion.value)}</>;
        return <>-</>
    }
    return (
        <FormControl fullWidth required={required} margin={margin}>
            <InputLabel shrink>{label}</InputLabel>
            <SelectSmart
                value={value?.toString() ?? (all?"-1":"")}
                onChange={(e:React.ChangeEvent<HTMLInputElement>)=> {
                    onChange({target:{name, value: e.target.value?+e.target.value:undefined}})
                }}
                name={name}
                loading={enums.status === "loading" }
                disabled={disabled}
                required={required}
                opciones={options}
            />
        </FormControl>
    );
}
